const getEncodedImageUrlPres = (
  key: string,
  width: number,
  height: number
): string => {
  var body = {
    bucket: process.env.REACT_APP_ASSET_BUCKET,
    key: key,
    edits: {
      resize: {
        width,
        height,
        fit: "cover",
        background: {
          r: 255,
          g: 255,
          b: 255,
          alpha: 1
        }
      }
    }
  };
  var encodedUrl = `${process.env.REACT_APP_IMAGE_HANDLER_URL}${btoa(
    JSON.stringify(body)
  )}`;
  return encodedUrl;
};

export default getEncodedImageUrlPres;
